import { render, staticRenderFns } from "./CarSelector.vue?vue&type=template&id=b8dd3064&scoped=true"
import script from "./CarSelector.vue?vue&type=script&lang=js"
export * from "./CarSelector.vue?vue&type=script&lang=js"
import style0 from "./CarSelector.vue?vue&type=style&index=0&id=b8dd3064&prod&scoped=true&lang=css"
import style1 from "./CarSelector.vue?vue&type=style&index=1&id=b8dd3064&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8dd3064",
  null
  
)

export default component.exports